"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateOPS = calculateOPS;
exports.calculateOSS = calculateOSS;
exports.calculateOMS = calculateOMS;
exports.default = _default;

var _calculationData = _interopRequireDefault(require("../utils/calculationData"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var yearBaseF = function yearBaseF(avgPayment) {
  return avgPayment;
};

function calculateOPS(avgPayment) {
  //Годовая база
  var yearBase = yearBaseF(avgPayment); // Если годовая база больше предельной

  if (yearBase > _calculationData.default.limitOfBaseOPS) {
    return _calculationData.default.limitOfBaseOPS * _calculationData.default.normal.taxRate + (yearBase - _calculationData.default.limitOfBaseOPS) * _calculationData.default.hight.taxRate;
  } // если годовая база меньше предельной


  return yearBase * _calculationData.default.normal.taxRate;
}
/**
 * Рассчет социальной страховки
 * @param avgPayment Средняя зп
 */


function calculateOSS(avgPayment) {
  var yearBase = yearBaseF(avgPayment);

  if (yearBase > _calculationData.default.limitOfBaseOSS) {
    return _calculationData.default.limitOfBaseOSS * _calculationData.default.normal.socialInsuranceDisable + (yearBase - _calculationData.default.normal.socialInsuranceDisable) * _calculationData.default.hight.socialInsuranceDisable;
  }

  return yearBase * _calculationData.default.normal.socialInsuranceDisable;
}
/**
 * Рассчет медицинской страховки
 * @param avgPayment Средняя ЗП
 */


function calculateOMS(avgPayment) {
  var yearBase = yearBaseF(avgPayment);
  return _calculationData.default.normal.oms * yearBase;
}
/**
 * Рассчет экономии предприятия
 * @param avgPayment Средняя ЗП
 * @param employees Количество работников
 */


function _default(avgPayment, employees) {
  var OPS = calculateOPS(avgPayment);
  var OSS = calculateOSS(avgPayment);
  var OMS = calculateOMS(avgPayment);
  return (OPS + OSS + OMS) * employees;
}